import { Link } from "react-router-dom";
import muxLogo from "@/assets/muxsignal-logo.png.asset.json";

export const Footer = () => {
  return (
    <footer className="border-t border-border mt-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <Link to="/" className="flex items-center gap-3">
            <img src={muxLogo.url} alt="MuxSignal Fleet Tracking and POTS Replacement" className="h-16 w-auto" />
            <span className="sr-only">MuxSignal</span>
          </Link>
          <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-muted-foreground">
            <Link to="/" className="hover:text-primary transition-colors">Fleet Tracking</Link>
            <Link to="/starlink-business-internet" className="hover:text-primary transition-colors">Starlink Business</Link>

            
            <Link to="/contact-us" className="hover:text-primary transition-colors">Contact</Link>
            <Link to="/terms-of-service" className="hover:text-primary transition-colors">Terms</Link>
            <Link to="/privacy-policy" className="hover:text-primary transition-colors">Privacy</Link>
            <Link to="/refund-policy" className="hover:text-primary transition-colors">Refunds</Link>
          </nav>
        </div>
        <div className="mt-8 pt-6 border-t border-border text-center text-xs text-muted-foreground">
          © {new Date().getFullYear()} MuxSignal. Operational Reliability, Delivered.
        </div>
      </div>
    </footer>
  );
};
